import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { IShippingMethodService } from '../models/shipping-method.model';

@Injectable({
  providedIn: 'root'
})
export class ShippingmethodService {

  constructor(private http: HttpClient) { }

  getShippingMethodList() {
    return this.http.get<any>(`${environment.inventoryURl}ShippingMethod/ShippingMethodHierarchy`);
  }

  deleteShippingMethod(id) {
    return this.http.delete<any>(`${environment.inventoryURl}ShippingMethod/${id}`)
      .toPromise()
      .then(res => res);
  }

  addShippingMethod(data) {
    return this.http.post<any>(`${environment.inventoryURl}ShippingMethod`, data)
      .toPromise()
      .then(res => res);
  }

  updateShippingMethod(data) {
    return this.http.put<any>(`${environment.inventoryURl}ShippingMethod`, data)
      .toPromise()
      .then(res => res);
  }

  getUpsServiceList(methodId: number) {
    return this.http.get<any>(`${environment.inventoryURl}ShippingMethod/ListShippingMethodServices?shippingMethodId=${methodId}`);
  }
  addUpsService(services: IShippingMethodService[]) {
    return this.http.post<any>(`${environment.inventoryURl}ShippingMethod/ListAddMultipleShippingMethodServices`, services);
  }

  getPaymentMethod() {
    return this.http.get<any>(`${environment.inventoryURl}PaymentMethod`);
  }


}
